import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, TemplateRef, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { IconDirective, TemplateContext, TypedTemplateDirective } from '@core/shared/util';

import { FilterSelectionOption } from '../../models';

export type OptionLabelTemplateContext<OptionValueType> = TemplateContext<FilterSelectionOption<OptionValueType>>;

export type OptionLabelTemplateRef<OptionValueType> = TemplateRef<OptionLabelTemplateContext<OptionValueType>>;

@Component({
  selector: 'mp-filter-option',
  templateUrl: './filter-option.component.html',
  styleUrl: './filter-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, DecimalPipe, MatIconModule, IconDirective, TypedTemplateDirective],
})
export class FilterOptionComponent<T> {
  readonly option: InputSignal<FilterSelectionOption<T>> = input.required<FilterSelectionOption<T>>();

  readonly optionLabelTemplate: InputSignal<OptionLabelTemplateRef<T> | undefined> = input<OptionLabelTemplateRef<T>>();

  readonly optionLabelTemplateContextType!: OptionLabelTemplateContext<T>;
}
